import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class LeaderboardSerializer extends BaseSerializer {
  deserialize(raw, currentUserId = null) {
    const serverRes = raw.data || raw.error;
    console.log("🚀 ~ LeaderboardSerializer ~ deserialize ~ serverRes:", serverRes);
    const success = serverRes.statusCode == 200 || serverRes.statusCode == 404;

    if (!success) {
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message:
          (serverRes.message || 'Erreur lors de la récupération du classement') +
          ` Code d'erreur: LEADERBOARD_ERR_${
            serverRes.statusCode || raw.status || '1000'
          }`,
        data: null
      };
    }

    const appInfo = serverRes?.data?.appInfo || {};
    console.log("🚀 ~ LeaderboardSerializer ~ deserialize ~ appInfo:", appInfo);

    // Parser et formater weekly leaders
    const weeklyLeaders = Array.isArray(appInfo.weeklyLeaders)
      ? appInfo.weeklyLeaders.map(this.formatPlayer)
      : [];

    // Parser et formater all-time leaders
    const allTimeLeaders = Array.isArray(appInfo.allTimeLeaders)
      ? appInfo.allTimeLeaders.map(this.formatPlayer)
      : [];

    // Trouver et formatter l'utilisateur courant pour weekly
    const weeklyCurrentUser = this.findCurrentUser(weeklyLeaders, currentUserId);

    // Trouver et formatter l'utilisateur courant pour alltime
    const alltimeCurrentUser = this.findCurrentUser(allTimeLeaders, currentUserId);

    return {
      statusCode: 200,
      success: true,
      message: 'Classement récupéré',
      data: {
        weekly: {
          leaders: weeklyLeaders,
          topThree: this.formatTopThree(weeklyLeaders.slice(0, 3), false),
          otherPlayers: weeklyLeaders.filter((p) => p.position > 3),
          currentUser: weeklyCurrentUser
        },
        alltime: {
          leaders: allTimeLeaders,
          topThree: this.formatTopThree(allTimeLeaders.slice(0, 3), true),
          otherPlayers: allTimeLeaders.filter((p) => p.position > 3),
          currentUser: alltimeCurrentUser
        }
      }
    };
  }

  formatPlayer(player) {
    return {
      position: player.position,
      name: player.name || 'Joueur',
      score: player.score || 0,
      bonus: player.bonus || 0,
      avatar: player.avatar || player.userId || 'default',
      userId: player.userId
    };
  }

  formatTopThree(players, isAllTime) {
    return players.map((p, index) => ({
      position: p.position,
      name: p.name,
      score: p.score,
      bonus: p.bonus,
      avatar: p.avatar,
      userId: p.userId,
      medal: isAllTime && index === 0 ? '👑' : index === 0 ? '🥇' : index === 1 ? '🥈' : '🥉'
    }));
  }

  findCurrentUser(players, userId) {
    if (!userId || !Array.isArray(players)) {
      // Valeur par défaut si pas d'utilisateur
      return {
        position: 0,
        name: 'Vous',
        score: 0,
        bonus: 0,
        avatar: 'default',
        isInTopThree: false
      };
    }

    const currentUser = players.find((p) => p.userId === userId);

    if (currentUser) {
      return {
        position: currentUser.position,
        name: 'Vous',
        score: currentUser.score,
        bonus: currentUser.bonus,
        avatar: currentUser.avatar,
        isInTopThree: currentUser.position <= 3
      };
    }

    // Si l'utilisateur n'est pas dans la liste, retourner null
    return null;
  }

  serialize() {}
}

export const serializer = new LeaderboardSerializer();
